import {
  selectMailbox,
  selectMailboxesByName,
  selectMailboxesByEmail,
} from 'selectors/mailboxes_base'
import { foldersByIdSelector, selectFolders } from 'selectors/folders_base'

// This file gets used by the performance simulator

export const getMailboxById = mailboxId => {
  const state = app.store.getState()
  return selectMailbox(state, mailboxId)
}

export const getMailboxByName = name => {
  const state = app.store.getState()
  return selectMailboxesByName(state)[name]
}

export const getMailboxByEmail = email => {
  const state = app.store.getState()
  return selectMailboxesByEmail(state)[email]
}

export const getMailboxFolderById = folderId => {
  const state = app.store.getState()
  return foldersByIdSelector(state)[folderId]
}

export const getMailboxFolderByName = name => {
  const state = app.store.getState()
  return selectFolders(state).find(x => x.name === name)
}
